import { getAuthClient } from "@tudigo-monorepo/core-tudigo-api";

export function getAuthorizeUrl(): string {
  const authClient = getAuthClient();
  const authUrl = authClient.authorizeUrl();

  return authUrl;
}
